(function ($, root, undefined) {
  $(function () {
    console.log("Meditation Works");
    $("#med-mobile-nav-trigger > span").click(function (e) {
      $(this).addClass("d-none");

      if ($(this).hasClass("closed")) {
        $(this).next().removeClass("d-none");
        $(".meditation-submenu .submenu-links").addClass("open");
      } else {
        $(this).prev().removeClass("d-none");
        $(".meditation-submenu .submenu-links").removeClass("open");
      }
    });

    $(".courses-area .mobile-courses-act").on("click", function () {
      if ($(this).hasClass("close")) {
        $(this).removeClass("close");
        $(this).addClass("open");

        $(".courses-area .courses-list .mobile-courses-accr").slideDown();
      } else {
        $(this).removeClass("open");
        $(this).addClass("close");

        $(".courses-area .courses-list .mobile-courses-accr").slideUp();
        $("html, body").animate(
          {
            scrollTop: $('#mobile-courses-accr').offset().top,
          },
          500
        );
      }
    });

    $('.course-list-filtering .filter .label').click(function(){
      if($(this).next().hasClass('open')){
        $(this).next().removeClass('open');        
      } else {
        $(this).next().addClass('open');
      }
    });

    $(document).click(function(event) {
      if (!$(event.target).closest(".course-list-filtering .filter ul, .course-list-filtering .filter .label").length) {
        $("body").find(".course-list-filtering .filter ul").removeClass("open");
      }
    });

    $('.course-list-filtering .filter ul li').on('click', function(){
      $(this).parent().children().removeClass('selected');
      $(this).addClass('selected');

      $(this).parent().removeClass('open');

      var currTxt = $(this).text();
      var currVal = $(this).data('value');
      $(this).parent().prev().find('.filter-label').text(currTxt);

      $('.courses-area .courses-list .single-product').addClass('display-none');

      if($(this).parent().hasClass('date')){
        $('.course-list-filtering .filter:last-child .label span.filter-label').text('Show all');
        $('.course-list-filtering .filter ul.frequency li').removeClass('selected');
        $('.course-list-filtering .filter ul.frequency li:last-child').addClass('selected');
        
        $('.courses-area .courses-list .single-product').removeClass('date-filtered');

        if(currVal == 0){
          $('.courses-area .courses-list .single-product[data-mon]').removeClass('display-none');
          $('.courses-area .courses-list .single-product[data-mon]').addClass('date-filtered');
        }
        
        $('.courses-area .courses-list .single-product[data-mon="'+ currVal +'"]').removeClass('display-none');
        $('.courses-area .courses-list .single-product[data-mon="'+ currVal +'"]').addClass('date-filtered');
      } else {
        $('.courses-area .courses-list .single-product').removeClass('date-freq');

        if(currVal == 0){
          $('.courses-area .courses-list .single-product[data-freq]').removeClass('display-none');
          $('.courses-area .courses-list .single-product[data-freq]').addClass('date-freq');
        }
        
        $('.courses-area .courses-list .single-product[data-freq="'+ currVal +'"]').removeClass('display-none');
        $('.courses-area .courses-list .single-product[data-freq="'+ currVal +'"]').addClass('date-freq');
      }

      
    });
  });
})(jQuery, this);
